/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button } from "components/Button";
import { useStepperContext } from "components/Steps";
import { ArrowBack as IconArrowBack } from "@material-ui/icons";
import * as S from "./styles";
import { Skeleton } from "components/Skeleton";
import { WrapperBanks } from "components/WrapperBanks";
import { ButtonContact } from "components/ButtonContact";

interface DetailsResultSacProps {
  financingAmountFormated: any;
  result: any;
}

export function DetailsResultSac({
  financingAmountFormated,
  result,
}: DetailsResultSacProps) {
  const { goToPreviousStep } = useStepperContext();

  return (
    <>
      <S.Container>
        <S.Title>
          O <strong>Comparetaxa</strong> comparou e escolheu o melhor para você!
        </S.Title>

        <S.SubTitle>
          Para um financiamento de <strong>{financingAmountFormated}</strong> no
          sistema de amortização <strong>SAC</strong>:
        </S.SubTitle>

        <S.WrapperResults>
          <S.ResultItem>
            <h3>Renda bruta mínima necessária</h3>
            <Skeleton showSkeleton={!result}>
              <span>{result?.minimumGrossIncomeRequired}</span>
            </Skeleton>
          </S.ResultItem>

          <S.ResultItem>
            <h3>Primeira parcela</h3>
            <Skeleton showSkeleton={!result}>
              <span>{result?.firstPayment}</span>
            </Skeleton>
          </S.ResultItem>

          <S.ResultItem>
            <h3>Última parcela</h3>
            <Skeleton showSkeleton={!result}>
              <span>{result?.lastPayment}</span>
            </Skeleton>
          </S.ResultItem>

          <S.ResultItem>
            <h3>Prazo de pagamento</h3>
            <Skeleton showSkeleton={!result}>
              <span>{result?.paymentTerm}</span>
            </Skeleton>
          </S.ResultItem>

          <S.ResultItem>
            <h3>Taxa de juros</h3>
            <Skeleton showSkeleton={!result}>
              <span>{result?.interestRate}</span>
            </Skeleton>
          </S.ResultItem>
        </S.WrapperResults>

        <S.WrapperButtons>
          <Button
            onClick={goToPreviousStep}
            startIcon={<IconArrowBack />}
            variant="outlined"
          >
            AJUSTAR SIMULAÇÃO
          </Button>
          <ButtonContact />
        </S.WrapperButtons>

        <S.WrapperTerms>
          <p>
            TODAS AS NOSSAS SIMULAÇÕES DO SITE ESTÃO COM BASE NO ÍNDICE TR,
            SENDO QUE ESTE ÍNDICE É O MAIS TRADICIONAL NO <br /> CRÉDITO
            IMOBILIÁRIO E NÃO COSTUMA TER VARIAÇÕES, SENDO A PRESTAÇÃO SIMULADA
            BEM PRÓXIMO DA REALIDADE A PAGAR.
          </p>

          <p>
            SITES CONCORRENTES PODEM APRESENTAR PRESTAÇÕES APARENTEMENTE MENORES
            MAS FIQUEM ATENTOS COM OS ÍNDICES <br /> UTILIZADOS (IPCA, CORREÇÃO
            DE POUPANÇA), POIS ESTES OUTROS ÍNDICES PODEM TRAZER GRANDES
            VARIAÇÕES NAS <br /> PRESTAÇÕES NO DECORRER DO PRAZO DE
            FINANCIAMENTO..
          </p>

          <p>
            CASO PREFIRA OUTRO ÍNDICE QUE NÃO SEJA A TR, FAVOR SOLICITAR A UM DE
            NOSSOS CONSULTORES
          </p>
        </S.WrapperTerms>

        <WrapperBanks />
      </S.Container>
    </>
  );
}
